import React, { useEffect } from 'react';

const HEART_URL = `${process.env.PUBLIC_URL || ''}/heart.svg`;

const LevelUpScreen = ({ level, title, subtitle, onComplete, duration = 2400 }) => {
  useEffect(() => {
    const timer = setTimeout(() => onComplete?.(), duration);
    return () => clearTimeout(timer);
  }, [onComplete, duration]);

  return (
    <>
      <style>{`
        .lvl-screen {
          position: fixed;
          inset: 0;
          z-index: 9999;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          background: linear-gradient(135deg, #F9FAFB 0%, #FFF1F1 100%);
          animation: lvl-fadeIn .3s ease-out;
          font-family: 'Poppins', -apple-system, BlinkMacSystemFont, sans-serif;
        }
        .lvl-badge {
          width: 80px;
          height: 80px;
          border-radius: 50%;
          background: linear-gradient(135deg, #D32F2F, #FF5252);
          display: flex;
          align-items: center;
          justify-content: center;
          box-shadow: 0 8px 32px rgba(211,47,47,0.25);
          animation: lvl-pop .5s cubic-bezier(.17,.67,.3,1.33);
          margin-bottom: 1.25rem;
        }
        .lvl-badge img {
          width: 44px;
          height: 44px;
          filter: brightness(0) invert(1);
        }
        .lvl-level {
          font-size: .75rem;
          font-weight: 600;
          color: #D32F2F;
          text-transform: uppercase;
          letter-spacing: .08em;
          margin-bottom: .35rem;
          animation: lvl-slideUp .4s ease-out .15s both;
        }
        .lvl-title {
          font-size: 1.4rem;
          font-weight: 700;
          color: #1E1E1E;
          margin: 0 0 .5rem;
          text-align: center;
          animation: lvl-slideUp .4s ease-out .25s both;
        }
        .lvl-sub {
          font-size: .9rem;
          color: #6B6B6B;
          text-align: center;
          max-width: 280px;
          line-height: 1.4;
          animation: lvl-slideUp .4s ease-out .35s both;
        }
        .lvl-stars {
          margin-top: 1rem;
          display: flex;
          gap: .25rem;
          animation: lvl-slideUp .4s ease-out .45s both;
        }
        .lvl-star {
          font-size: 1.2rem;
          animation: lvl-twinkle .6s ease-in-out infinite alternate;
        }
        .lvl-star:nth-child(2) { animation-delay: .15s; }
        .lvl-star:nth-child(3) { animation-delay: .3s; }
        @keyframes lvl-fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        @keyframes lvl-pop {
          0% { transform: scale(0); }
          70% { transform: scale(1.15); }
          100% { transform: scale(1); }
        }
        @keyframes lvl-slideUp {
          from { opacity: 0; transform: translateY(12px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @keyframes lvl-twinkle {
          from { opacity: .5; transform: scale(.9); }
          to { opacity: 1; transform: scale(1.1); }
        }
      `}</style>
      <div
        className="lvl-screen"
        role="dialog"
        aria-modal="true"
        aria-labelledby="lvl-title"
      >
        <div className="lvl-badge" aria-hidden="true">
          <img src={HEART_URL} alt="" />
        </div>
        {level != null && <div className="lvl-level">Nivel {level} alcancado!</div>}
        <h2 id="lvl-title" className="lvl-title deco-headline">{title}</h2>
        {subtitle && <p className="lvl-sub">{subtitle}</p>}
        <div className="lvl-stars" aria-hidden="true">
          <span className="lvl-star">⭐</span>
          <span className="lvl-star">⭐</span>
          <span className="lvl-star">⭐</span>
        </div>
      </div>
    </>
  );
};

export default LevelUpScreen;
